import { Moment } from 'moment'
import { adminHttpClient } from '../../commons/adminHttpClient'
import OrderedPageFilter from '../../commons/orderedPageFilter'
import PagedList from '../../commons/PagedList'
import { UserRoles } from '../../account/userRoles'
import CompanyUserStatus from '../../../domain/companies/CompanyUserStatus'

export interface PagedCompanyEmployees extends PagedList<CompanyEmployee> {}

export type CompanyEmployee = {
  id: string
  fullName: string
  workEmail: string
  roles: string[]
  status: string
  benefitParticipationStatus: string
  eligible: boolean
  createdAt: string
  terminatedDate: string
  canBeImpersonate: string
  canSetPassword: boolean
  userId: string
}

export type CompanyEmployeeFilter = {
  pageNumber: number
  pageSize: number
  orderColumn: string
  orderDescending: boolean
  companyId: string
  q?: string
  userRole?: UserRoles
  status?: CompanyUserStatus
  productId?: number
}

const getCompanyEmployees = (filter: CompanyEmployeeFilter): Promise<PagedCompanyEmployees> => {
  filter = filter || {
    pageNumber: 1,
    pageSize: 10,
    orderColumn: 'createdAt',
    orderDescending: false,
  }

  return adminHttpClient.get('/csi/CompanyEmployees', {
    ...filter,
  })
}

export default getCompanyEmployees
